<template>
    <div class="reset-password-form">
        <div class="reset-password-form__header">
            <h1>{{ $t('template.resetPassword.heading') }}</h1>
            <p v-if="!requestSent">{{ $t('template.resetPassword.description') }}</p>
            <p v-else>{{ $t('template.resetPassword.checkEmail', { account: form.items.email.value }) }}</p>
        </div>

        <form v-if="!requestSent" class="form" @submit.prevent="onSubmit">
            <template v-for="key in form.fieldKeys" :key="key">
                <FormItem v-bind="form.items[key].props" :name="key">
                    <component
                        :is="form.items[key].component"
                        :name="key"
                        v-model="form.items[key].value"
                        v-bind="form.items[key].props"
                        @update-field="onUpdateFieldValue"
                    />
                </FormItem>
            </template>
            <FormError v-if="form.errors.length" :errors="form.errors" />

            <div class="form-button">
                <Button icon="check">{{ $t('template.resetPassword.buttons.submit') }}</Button>

                <router-link to="/login" active-class="active" class="btn btn-text">
                    <span class="btn__icon material-icons-outlined">keyboard_arrow_left</span>
                    <span>{{ $t('template.resetPassword.buttons.back') }}</span>
                </router-link>
            </div>
        </form>
    </div>
</template>

<script>
import Form from '@/entities/form';
import validateField from '@/entities/validator';
import AuthService from '@/services/AuthService.ts';
import FormItem from '@/components/form/item.vue';
import FormError from '@/components/form/error.vue';
import InputText from '@/components/form/controls/inputText.vue';
import InputPassword from '@/components/form/controls/inputPassword.vue';
import Button from '@/components/common/button.vue';
import EventEmitter from '@/helpers/eventEmitter';

export default {
    name: 'requestPasswordResetForm',
    components: {
        FormItem,
        FormError,
        InputText,
        InputPassword,
        Button,
    },
    data() {
        return {
            id: 'test',
            requestSent: false,
            form: new Form({
                action: this.formAction,
                validateHandler: this.validateHandler,
                successHandler: this.successHandler,
                failedHandler: this.failedHandler,
                items: {
                    email: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: ['email', 'noEmpty'],
                            label: this.$t('template.resetPassword.fields.email'),
                        },
                    },
                },
            }),
        };
    },
    methods: {
        formAction(formData) {
            return AuthService.requestPasswordReset(formData.email);
        },
        validateHandler(isValid) {
            console.log('validateHandler', isValid);
        },
        successHandler(result) {
            console.log('successHandler', result);
            localStorage.setItem('email', this.form.items.email.value);
            this.requestSent = true;
        },
        failedHandler(result) {
            if (result.status === 400) {
                this.form.errors = ["Can't find an account for this email"];
            } else {
                EventEmitter.trigger('show-noty', {
                    type: 'error',
                    text: 'Unknown error',
                });
            }
        },
        onSubmit() {
            this.form.submit();
        },
        onUpdateFieldValue(payload) {
            const { name } = payload;
            const item = this.form.items[name];
            item.props.errors = validateField(item.value, item.props.rules);
        },
    },
};
</script>

<style lang="scss">
.reset-password-form {
    display: block;
    width: 100%;
    &__header {
        margin-bottom: 28px;
    }
    h1 {
        margin-top: 0;
        font-size: 33px;
        margin-bottom: 20px;
    }
}

.form-button {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
}
</style>
